import { useState } from 'react';
import { BiLinkAlt } from 'react-icons/bi';
import { MdEmail } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { EmailShareButton } from 'react-share';
import CircleIcon from 'components/CircleIcon';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function ShareSocialMedia({ brandName }) {
  const { theme } = useSelector((state) => state.ui);
  const [showCopyMessage, setShowCopyMessage] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setShowCopyMessage(true);
    setTimeout(() => setShowCopyMessage(false), 2000);
  };
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <div
      style={{ background: theme.secondaryColour || DEFAULT_PRIMARY_COLOUR }}
      className="text-white rounded-lg relative max-w-[330px] w-full md:h-full lg:h-auto"
    >
      <div className="px-4 py-5">
        <p className="text-[24px] font-medium">Share your quote</p>
        <div className="mt-4 flex">
          <div className="mr-2">
            <EmailShareButton
              subject={
                brandName
                  ? `Take a look at this quote from ${brandName}`
                  : 'Take a look at this quote'
              }
              body={window.location.href}
            >
              <CircleIcon
                iconClassName="text-xl"
                className="border-2 border-transparent [@media(hover:hover){&:hover}]:border-white"
              >
                <MdEmail style={{ fill: primaryColour }} />
              </CircleIcon>
            </EmailShareButton>
          </div>
          <div>
            <button type="button" onClick={copyLink}>
              <CircleIcon
                iconClassName="text-xl"
                className="border-2 border-transparent [@media(hover:hover){&:hover}]:border-white"
              >
                <BiLinkAlt style={{ fill: primaryColour }} />
              </CircleIcon>
            </button>
          </div>
        </div>
      </div>
      {showCopyMessage && (
        <p className="absolute -top-6 text-black right-1/2 translate-x-1/2">
          Link Copied
        </p>
      )}
    </div>
  );
}
